import { LOCAL } from "@/store/mutations";

const { ACTIVATE_TUTORIAL_MASK, DEACTIVATE_TUTORIAL_MASK } = LOCAL;

export default {
	namespaced: true,
	state: {
		active: false,
		element: null,
		interactive: false,
	},
	actions: {
		activate({ commit }, mask) {
			commit(ACTIVATE_TUTORIAL_MASK, mask);
		},
		deactivate({ commit }) {
			commit(DEACTIVATE_TUTORIAL_MASK);
		},
	},
	mutations: {
		[ACTIVATE_TUTORIAL_MASK](state, mask) {
			state.active = true;
			state.element = mask.element;
			state.interactive = mask.interactive;
		},
		[DEACTIVATE_TUTORIAL_MASK](state) {
			state.active = false;
			state.element = null;
			state.interactive = false;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/tutorial/mask.store.js